export enum ImportErrorCode {
    IMPORT_ELEMENTS_DUPLICATE_HEADER_ERROR = "IMPORT_ELEMENTS_DUPLICATE_HEADER_ERROR",
    IMPORT_ELEMENTS_INSUFFICIENT_RIGHTS = "IMPORT_ELEMENTS_INSUFFICIENT_RIGHTS",
    IMPORT_MODEL_INSUFFICIENT_RIGHTS = "IMPORT_MODEL_INSUFFICIENT_RIGHTS",
    IMPORT_RELATIONSHIP_INSUFFICIENT_RIGHTS = "IMPORT_RELATIONSHIP_INSUFFICIENT_RIGHTS",
    CONFLICTING_VERSION = "CONFLICTING_VERSION",
}
